<div>
    <ul class="flex space-x-2 rtl:space-x-reverse">
        <li>
            <a href="javascript:;" class="text-primary hover:underline">Forms</a>
        </li>
        <li class="before:content-['/'] ltr:before:mr-2 rtl:before:ml-2">
            <span>Select2</span>
        </li>
    </ul>
    <div class="space-y-8 pt-5">
        <div class="panel flex items-center overflow-x-auto whitespace-nowrap p-3 text-primary">
            <div class="rounded-full bg-primary p-1.5 text-white ring-2 ring-primary/30 ltr:mr-3 rtl:ml-3">
                <icon-bell />
            </div>
            <span class="ltr:mr-3 rtl:ml-3">Documentation: </span
            ><a href="https://www.npmjs.com/package/@ng-select/ng-select" target="_blank" class="block hover:underline"
                >https://www.npmjs.com/package/@ng-select/ng-select</a
            >
        </div>

        <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
            <!-- Basic -->
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Basic</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code1')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <ng-select [items]="options" [(ngModel)]="input1" [searchable]="false" [clearable]="false" class="custom-multiselect"> </ng-select>
                </div>
                <ng-container *ngIf="codeArr.includes('code1')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- basic --&gt;
&lt;ng-select
    [items]=&quot;options&quot;
    [(ngModel)]=&quot;input1&quot;
    [searchable]=&quot;false&quot;
    [clearable]=&quot;false&quot;
    class=&quot;custom-multiselect&quot;
&gt;
&lt;/ng-select&gt;

&lt;!-- script --&gt;
options = ['Orange', 'White', 'Purple'];
input1 = 'Orange';"></code> </pre>
                </ng-container>
            </div>

            <!-- Nested -->
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Nested</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code2')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <ng-select
                        [items]="options2"
                        bindLabel="name"
                        bindValue="name"
                        [(ngModel)]="input2"
                        [clearable]="false"
                        [searchable]="false"
                        placeholder="Select Option"
                        groupBy="group_name"
                        class="custom-multiselect"
                    >
                    </ng-select>
                </div>
                <ng-container *ngIf="codeArr.includes('code2')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- nested --&gt;
&lt;ng-select
    [items]=&quot;options2&quot;
    bindLabel=&quot;name&quot;
    bindValue=&quot;name&quot;
    [(ngModel)]=&quot;input2&quot;
    [clearable]=&quot;false&quot;
    [searchable]=&quot;false&quot;
    placeholder=&quot;Select Option&quot;
    groupBy=&quot;group_name&quot;
    class=&quot;custom-multiselect&quot;
&gt;
&lt;/ng-select&gt;

&lt;!-- script --&gt;
options2 = [
    { name: 'Orange', group_name: 'Group 1' },
    { name: 'White', group_name: 'Group 1' },
    { name: 'Purple', group_name: 'Group 1' },
    { name: 'Yellow', group_name: 'Group 2' },
    { name: 'Red', group_name: 'Group 2' },
    { name: 'Green', group_name: 'Group 2' },
    { name: 'Aqua', group_name: 'Group 3' },
    { name: 'Black', group_name: 'Group 3' },
    { name: 'Blue', group_name: 'Group 3' },
];
input2 =  'Orange';"></code> </pre>
                </ng-container>
            </div>

            <!-- Disabling options -->
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Disabling options</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code3')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <ng-select
                        [items]="options3"
                        bindLabel="name"
                        bindValue="name"
                        [(ngModel)]="input3"
                        [clearable]="false"
                        [searchable]="false"
                        placeholder="Select Option"
                        class="custom-multiselect"
                    >
                    </ng-select>
                </div>
                <ng-container *ngIf="codeArr.includes('code3')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- disabling options --&gt;
&lt;ng-select
    [items]=&quot;options3&quot;
    bindLabel=&quot;name&quot;
    bindValue=&quot;name&quot;
    [(ngModel)]=&quot;input3&quot;
    [clearable]=&quot;false&quot;
    [searchable]=&quot;false&quot;
    placeholder=&quot;Select Option&quot;
    class=&quot;custom-multiselect&quot;
&gt;
&lt;/ng-select&gt;

&lt;!-- script --&gt;
options3 = [{ name: 'Orange' }, { name: 'White', disabled: true }, { name: 'Purple' }];
input3 = 'Orange';"></code> </pre>
                </ng-container>
            </div>

            <!-- Placeholder -->
            <div class="panel lg:row-start-3">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Placeholder</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code4')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <ng-select
                        [items]="options"
                        [(ngModel)]="input4"
                        [clearable]="false"
                        [searchable]="false"
                        placeholder="Choose..."
                        class="custom-multiselect"
                    >
                    </ng-select>
                </div>
                <ng-container *ngIf="codeArr.includes('code4')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- placeholder --&gt;
&lt;ng-select
    [items]=&quot;options&quot;
    [(ngModel)]=&quot;input4&quot;
    [clearable]=&quot;false&quot;
    [searchable]=&quot;false&quot;
    placeholder=&quot;Choose...&quot;
    class=&quot;custom-multiselect&quot;
&gt;
&lt;/ng-select&gt;

&lt;!-- script --&gt;
options = ['Orange', 'White', 'Purple'];
input4 : string  | undefined;"></code> </pre>
                </ng-container>
            </div>

            <!-- Searchable -->
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Searchable</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code5')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <ng-select [items]="options" [(ngModel)]="input5" [clearable]="false" placeholder="Select an option" class="custom-multiselect">
                    </ng-select>
                </div>
                <ng-container *ngIf="codeArr.includes('code5')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- searchable --&gt;
&lt;ng-select
    [items]=&quot;options&quot;
    [(ngModel)]=&quot;input5&quot;
    [clearable]=&quot;false&quot;
    placeholder=&quot;Select an option&quot;
    class=&quot;custom-multiselect&quot;
&gt;
&lt;/ng-select&gt;

&lt;!-- script --&gt;
options = ['Orange', 'White', 'Purple'];
input5 : string  | undefined;"></code> </pre>
                </ng-container>
            </div>

            <!-- Multiple -->
            <div class="panel">
                <div class="mb-5 flex items-center justify-between">
                    <h5 class="text-lg font-semibold dark:text-white-light">Multiple select</h5>
                    <a class="font-semibold hover:text-gray-400 dark:text-gray-400 dark:hover:text-gray-600" href="javascript:;" (click)="toggleCode('code6')">
                        <span class="flex items-center">
                            <icon-code class="me-2" />
                            Code
                        </span>
                    </a>
                </div>
                <div class="mb-5">
                    <ng-select
                        [items]="options"
                        [(ngModel)]="input6"
                        [multiple]="true"
                        [clearable]="false"
                        placeholder="Select an option"
                        class="custom-multiselect"
                    >
                    </ng-select>
                </div>
                <ng-container *ngIf="codeArr.includes('code6')">
                    <pre> <code [languages]="['xml','typescript']" highlight="&lt;!-- multiple --&gt;
&lt;ng-select
    [items]=&quot;options&quot;
    [(ngModel)]=&quot;input6&quot;
    [multiple]=&quot;true&quot;
    [clearable]=&quot;false&quot;
    placeholder=&quot;Select an option&quot;
    class=&quot;custom-multiselect&quot;
&gt;
&lt;/ng-select&gt;

&lt;!-- script --&gt;
options = ['Orange', 'White', 'Purple'];
input6 = [];"></code> </pre>
                </ng-container>
            </div>
        </div>
    </div>
</div>
